import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';
import { Injector } from '@angular/core';
import { makeStateKey, StateKey, TransferState } from '@angular/core';
import { ApiTranslationService } from '../services/api/api-translation.service';

export class CustomTranslateHttpLoader extends TranslateLoader {
  constructor(private readonly injector: Injector) {
    super();
  }

  override getTranslation(lang: string): Observable<Object> {
    const translationService = this.injector.get(ApiTranslationService);
    const transferState = this.injector.get(TransferState);
    const key: StateKey<number> = makeStateKey<number>(lang);

    if (transferState.hasKey(key)) {
      return of(transferState.get<Object>(key, {}) as Object);
    }

    return translationService.getForLanguage(lang, new Date().getTime().toString())
      .pipe(map(response => {
        transferState.set(key, response as Object);
        return response as Object;
      }));
  }
}
